import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import moment from 'moment';

import { ITEMS_PER_PAGE } from '../../constants/constants';

const InventoryAuditTableRow = (props) => {
    return(
      <tr>
        <td>
          <NavLink to={`/inventory/${props.inventory.id}`}>{props.inventory ? props.inventory.id : ''}</NavLink>
        </td>
        <td>{props.inventory ? props.inventory.item__name : '-'}</td>
        {props.inventory && props.inventory.weight?
          (
            <td>
              <span>{props.inventory.weight}</span>
              <span className="badge badge-pill badge-info ml-025">
                {props.inventory.measure_unit? props.inventory.measure_unit : 'kg'}
              </span>
            </td>
          ):
          <td>
            <span>-</span>
          </td>
         }
        <td>{props.inventory &&  props.inventory.packing_date ? moment(props.inventory.packing_date).format('MM/DD/YYYY') : '-'}</td>
        <td>{props.inventory ? props.inventory.number_items : '-'}</td>
        <td>{props.inventory ? props.inventory.item_brand_grade : '-'}</td>
        <td>{props.inventory ? props.inventory.qb_mapping : '-'}</td>
      </tr>
    )
};

export default class InventoryAuditResult extends Component  {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);

    this.state = {
      currentPage: 1,
      currentList: [],
      numOfPages: 0
    };

    this.handlePageRequest = this.handlePageRequest.bind(this);
  }

  componentDidMount(){
    let currentList = this.props.list.slice(0, ITEMS_PER_PAGE);
    let numOfPages = Math.ceil(this.props.list.length / ITEMS_PER_PAGE);
    this.setState({ currentList, numOfPages });
  }

  // ---------------------------------------------------------------------------
  // Page handling
  // ---------------------------------------------------------------------------
  handlePageRequest(data){
    let currentPage = data.selected + 1;
    if(currentPage !== this.state.currentPage){
      this.setState({ currentPage }, () => {
          this.updateItems();
      });
    };
  }

  updateItems(){
    let i_0 = this.state.currentPage*ITEMS_PER_PAGE-ITEMS_PER_PAGE;
    let i_n = this.state.currentPage*ITEMS_PER_PAGE;
    let currentList = this.props.list.slice(i_0, i_n);
    this.setState({ currentList });
  }

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    return (
      <div className="card">
        <div className="card-header">
          <h5 className="d-flex align-items-center mb-0">
            <i className={this.props.iconClass} aria-hidden="true"></i>
            <span>{this.props.title}</span>
          </h5>
        </div>
        <div className="card-block p-0">
          <table className="table table-striped table-bordered datatable m-0">
            <thead>
              <tr>
                <th>Id</th>
                <th>Item</th>
                <th>Weight</th>
                <th>Packing date</th>
                <th>Count</th>
                <th>Item description</th>
                <th>QB Mapping</th>
              </tr>
            </thead>
            <tbody>
              {this.state.currentList.map((i, idx) => {
                  return <InventoryAuditTableRow inventory={i}
                                                 key={idx} />
                })
              }
            </tbody>
          </table>
          {this.state.numOfPages > 1 &&
          <ReactPaginate pageCount={this.state.numOfPages}
                         pageRangeDisplayed={2}
                         marginPagesDisplayed={2}
                         previousLabel="Prev"
                         nextLabel="Next"
                         onPageChange={this.handlePageRequest}
                         initialPage={this.state.currentPage-1}
                         disableInitialCallback={true}
                         containerClassName="pagination"
                         pageClassName="page-item"
                         pageLinkClassName="page-link"
                         activeClassName="page-item active"
                         previousClassName="paginate_button previous"
                         nextClassName="paginate_button next"
                         disabledClassName="page-item disabled"
          />
         }
        </div>
      </div>
    );
  }

};
